export interface DefaultSettings{
    sentryDsn:string,
    host:string,
    env: string,
    projectName:string,

}

export default {
    // sentryDsn:"https://3ede05a745ad499794b9976f3dd512c9@sentry.qiangfen.com/9", //线下
    sentryDsn:"https://ec73c5bc73bb4653a81b6f9c992c4cd4@sentry.qiangfen.com/10", //线上
    host:'http://dev-put.qiangfen.com/',
    env: "production",
    projectName:'qf-react-app-online',
} as DefaultSettings

